import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import AppProps from "../../static/js/AppProps"

export default function ProductInformation() {
    const { id } = useParams();

    const [product, setProduct] = useState(null);
    const [layers, setLayers] = useState([]);
    const [featuresByLayer, setFeaturesByLayer] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const productRes = await fetch(`${AppProps.spring_server_url}/products?id=${id}`);
                const productData = await productRes.json();
                setProduct(productData);
                setLayers(productData.layers || []);

                const featuresMap = {};
                for (const { id: layerId } of productData.layers || []) {
                    const featureRes = await fetch(`${AppProps.spring_server_url}/features/by-layer?id=${layerId}`);
                    featuresMap[layerId] = await featureRes.json();
                }

                setFeaturesByLayer(featuresMap);
            } catch (e) {
                console.error(e);
                setError("Ошибка при загрузке данных");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [id]);

    if (loading) return <div className="container py-4"><p>Загрузка...</p></div>;
    if (error) return <div className="container py-4"><p className="text-danger">{error}</p></div>;

    return (
        <section className="bg-light py-5">
            <div className="container">
                <h2 className="text-center mb-4 text-primary">Информация о продукте</h2>

                {product && (
                    <div className="card shadow-sm p-4 mb-5">
                        <h3 className="mb-3">{product.full_name}</h3>
                        <p><strong>Категория:</strong> {product.category} / {product.subcategory}</p>
                        <p><strong>Описание:</strong> {product.description}</p>
                        <p><strong>Цена:</strong> {product.price.toLocaleString()} ₽</p>
                    </div>
                )}

                <h4 className="mb-3">Слои и их содержание</h4>
                <div className="row">
                    {layers.map((layer) => (
                        <div className="col-md-6 mb-4" key={layer.id}>
                            <div className="card h-100 shadow-sm">
                                <div className="card-body">
                                    <h5 className="card-title text-secondary">{layer.full_name ?? 'Без названия слоя'}</h5>
                                    <ul className="list-group list-group-flush mt-3">
                                        {Array.isArray(featuresByLayer[layer.id]) &&
                                            featuresByLayer[layer.id].map((feature) => (
                                                <li key={feature.id} className="list-group-item bg-transparent">
                                                    {typeof feature.full_name === 'string'
                                                        ? feature.full_name
                                                        : feature.full_name?.ru ?? 'Без названия фичи'}
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}